import React, { Component } from "react";
import { Redirect, Link, history } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import DatePicker from "react-datepicker";
import moment from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
class LeadList extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			customers: [],
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			activePage: 1,
			item_count: "",
			from_date: "",
			to_date: "",
			search: "",
			studio_id: "",
			user_id: "",
			purchase_url: "",
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			isLoadMore: 1,
			Loading: 1,
			muvisixproductkey: "3D28C83C85544F0D9517DD2E7C7EEDAA",
			customerByproductName: [],
			menusOpen: false,
			showMenu: false,
			allmuvisix: [],
			offset: 0,
			muviFiveCount: null,
			isMuviOne: false,
			free_trail_apptoken: "",
			free_trail_productkey: "",
			free_trail_storeKey: "",
			free_trail_useruid: "",
			startDate: new Date(),
			minDate: new Date(),
			free_trial_expiry_date: new Date(),
			new_free_trial_date: "",
			errors: {},
			item_name: "",
			item_description: "",
			invoice_amount: "",
			store_permission: localStorage.getItem("store_permission"),
			is_general_user: localStorage.getItem("is_general_user"),
		};
		this.onChange = this.onChange.bind(this);
		this.getCustomers = this.getCustomers.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.formdateChange = this.formdateChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
		this.customer_details = this.customer_details.bind(this);
		this.get_customer_details = this.get_customer_details.bind(this);
		this.movetoDemo = this.movetoDemo.bind(this);
		this.handleChangeStart = this.handleChangeStart.bind(this);
		this.handleChangeStartMuvi6 = this.handleChangeStartMuvi6.bind(this);
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}
	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}
	goToCustomerStore(email, password, studio_id, studio_name) {
		if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
			var win = window.open(
				this.state.studioUrl +
					"/login/storeLogin" +
					"?email=" +
					email +
					"&password=" +
					password +
					"&studio_id=" +
					studio_id,
				"_blank"
			);
			win.focus();
		}
	}
	formdateChange(event) {
		this.setState({ from_date: event.target.value }, function () {
			this.getCustomers();
		});
	}
	handleChangeStart(date) {
		this.setState({
			startDate: Date.parse(date),
			start_date: moment(date).format("YYYY-MM-DD"),
		});
	}
	handleChangeStartMuvi6(date) {
		this.setState({
			free_trial_expiry_date: Date.parse(date),
			new_free_trial_date: moment(date).format("MM-DD-YYYY"),
		});
	}
	todateChange(event) {
		this.setState({ to_date: event.target.value }, function () {
			this.getCustomers();
		});
	}
	keywordChange(event) {
		var obj = this;
		this.setState({
			search: event.target.value,
			activePage: 1,
			customers: [],
			Loading: 1,
		});
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		if (obj.state.muvisixproductkey != "") {
			this.timer = window.setTimeout(() => {
				obj.muvisixCustomerSearchHandler();
			}, 500);
		} else {
			this.timer = window.setTimeout(function () {
				//Execute the function code here...
				obj.getCustomers();
			}, 500);
		}
	}

	muvisixCustomerSearchHandler = () => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${this.state.muvisixproductkey}", type: \"Lead\", page: 0, size: 20, search : \"${this.state.search}") {page_info{total_count}, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, country_name, number_of_login, domain_name}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((data) => {
						this.setState({
							customers: data.data.getCustomerList.user_details,
							item_count: data.data.getCustomerList.page_info.total_count,
							Loading: 0,
						});
					});
			}
		);
	};
	customer_details(studio_id, studio_name, user_id) {
		document.getElementById("new_password").value = "";
		this.setState({ message1: "" });
		fetch(
			this.state.apiUrl +
				"/AdminRest/customerdetails/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					user_id: findresponse.user_id,
				});

				if (this.state.studio_id.start_date != "0000-00-00") {
					let x = new Date(this.state.studio_id.start_date);
					this.setState({ startDate: x });
				}
			});
	}

	get_customer_details(apptoken, productkey, storeKey, useruid, free_trial_expiry_date, company_name) {
		this.setState({
			free_trail_apptoken: apptoken,
			free_trail_productkey: productkey,
			free_trail_storeKey: storeKey,
			free_trail_useruid: useruid,
			company_name: company_name,
		});

		if (free_trial_expiry_date != "0000-00-00") {
			let x = new Date(free_trial_expiry_date);
			this.setState({ free_trial_expiry_date: x });
		}
	}

	movetoDemo(studio_id, studio_name, user_id) {
		if (window.confirm("Are you sure you want to move '" + studio_name + "' account to demo studio?")) {
			fetch(
				this.state.apiUrl + "/adminRest/movetoDemo/id/" + studio_id + "/userAuthKey/" + this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message: findresponse.msg });
					} else {
						this.setState({ message: findresponse.msg });
					}
					this.getCustomers();
					this.setState({});
				});
		}
	}

	leadMovetoDemo = async (productKey, appToken, moveToDemo, userId, username, name, storeKey = "") => {
		if (window.confirm("Are you sure you want to move '" + name + "' account to demo studio?")) {
			this.setState({
				menusOpen: false,
				showMenu: false,
			});
			fetch("https://apigateway.muvi.com/accounts/manage-demo-account", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					product_key: productKey,
					app_token: appToken,
					is_demo: moveToDemo,
					user_uuid: userId,
					store_key: storeKey,
				}),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.fetchProductByKey(productKey);
				});
		}
	};
	ExtendTrialPeriod(studio_id) {
		if (window.confirm("Are you sure you want to extend trial period?")) {
			fetch(
				this.state.apiUrl +
					"/AdminRest/ExtendTrialPeriod/studio_id/" +
					studio_id +
					"/start_date/" +
					this.state.start_date +
					"/userAuthKey/" +
					this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message1: findresponse.msg }, function () {
							window.location.href = "/leads";
						});
					} else {
						this.setState({ message1: findresponse.msg });
					}
				});
		}
	}

	ExtendTrialPeriodMuvi6(
		free_trail_apptoken,
		free_trail_productkey,
		free_trail_storeKey,
		free_trail_useruid,
		new_free_trial_date
	) {
		if (window.confirm("Are you sure you want to extend trial period?")) {
			$("#extend_free_trial_close").click();
			fetch("https://apigateway.muvi.com/accounts/extend-free-trial", {
				method: "POST",
				headers: {
					"content-type": "application/json",
				},
				body: JSON.stringify({
					app_token: free_trail_apptoken,
					product_key: free_trail_productkey,
					store_key: free_trail_storeKey,
					user_uuid: free_trail_useruid,
					new_free_trial_date: new_free_trial_date,
				}),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.fetchProductByKey(free_trail_productkey);
				});
		}
	}

	CancelAccount(studio_id, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/CancelAccount/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message1: findresponse.msg }, function () {
						window.location.href = "/leads";
					});
				} else {
					this.setState({ message1: findresponse.msg });
				}
			});
	}
	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
				"/adminRest/GetLeads/page/" +
				pageNumber +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.customers.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					//isLoadMore:1,
					customers: this.state.customers.concat(findresponse.customers),
					//item_count: findresponse.item_count,
				});
			});
	}

	isValidNumber(number) {
		var pattern = /^[0-9]*\.?[0-9]*$/;
		return pattern.test(number);
	}

	handleValidation() {
		let errors = {};
		let formIsValid = true;
		if (!this.state.item_name) {
			formIsValid = false;
			errors["item_name"] = "This field is required.";
		}
		if (!this.state.item_description) {
			formIsValid = false;
			errors["item_description"] = "This field is required.";
		}
		if (!this.state.invoice_amount) {
			formIsValid = false;
			errors["invoice_amount"] = "This field is required.";
		}
		if (this.state.invoice_amount && !this.isValidNumber(this.state.invoice_amount)) {
			formIsValid = false;
			errors["invoice_amount"] = "Invalid Amount";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	setInvoiceDetails(userid, companyname) {
		this.flag = 0;
		this.setState({
			message: "",
			userid: userid,
			customer_name_muvi6: companyname,
			item_name: "",
			item_description: "",
			invoice_amount: "",
		});
		document.getElementById("raiseInvoiceModal").style.display = "block";
	}

	submitInvoice() {
		this.flag = 0;
		if (this.handleValidation()) {
		} else {
			return false;
		}
		document.getElementById("submit_invoice").innerHTML = "Sending....";
		document.getElementById("submit_invoice").disabled = true;
		this.raiseInvoice(
			this.state.item_name,
			this.state.item_description,
			this.state.invoice_amount,
			this.state.muvisixproductkey,
			this.state.userid,
			this.state.activePage - 1
		);
		setTimeout(() => {
			this.flag = 1;
		}, 3000);
	}
	raiseInvoice(item_name, item_description, invoice_amount, productkey, userid, activePage) {
		const loginDetails = {
			product_key: `${productkey}`,
			user_uuid: `${userid}`,
			muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
			item_name: `${item_name}`,
			item_description: `${item_description}`,
			invoice_amount: `${invoice_amount}`,
		};
		fetch(this.state.apiUrl + "/adminRest/raiseCustomInvoice/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			//            headers: {
			//                'content-type': 'application/json'
			//            },
			dataType: "json",
			body: JSON.stringify(loginDetails),
		})
			.then((Response) => Response.json())
			.then((data) => {
				if (data.code == 200) {
					this.setState(
						{
							code: data.code,
							message: data.message,
						},
						function () {
							window.location.href = "/leads";
						}
					);
				} else {
					this.setState({
						message: data.message,
					});
				}
				document.getElementById("submit_invoice").innerHTML = "Submit Invoice";
				document.getElementById("submit_invoice").disabled = false;
			});
	}

	Savepassword(studio_id, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/Savepassword/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () {
						window.location.href = "/leads";
					});
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}
	export() {
		var win = window.open(
			this.state.apiUrl +
				"/AdminRest/ExportUsers/userAuthKey/" +
				this.state.userAuthKey +
				"/user_type/lead/search/" +
				this.state.search,
			"_self"
		);
		win.focus();
	}

	menuHideShow = () => {
		this.setState({
			showMenu: !false,
		});
	};

	userDataEncrypt = async (productkey, userid, uname) => {
		const REDIRECT_URL = `https://account.muvi.com`;
		if (window.confirm(`Are you sure to login this store ${uname}`)) {
			const loginDetails = {
				product_key: `${productkey}`,
				user_uuid: `${userid}`,
				muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
			};

			const response = await fetch(
				this.state.apiUrl + "/adminRest/encData/userAuthKey/" + this.state.userAuthKey,
				{
					method: "POST",
					// headers: {
					//     'content-type': 'application/json'
					// },
					body: JSON.stringify(loginDetails),
				}
			);

			const user_data = await response.json();

			this.setState(
				{
					user_data,
					showMenu: false,
					loadMore: 0,
				},
				async () => {
					try {
						const loginRespnse = await fetch(`${this.state.apiUrl}/AdvancedRest/getintraLogin`, {
							method: "POST",
							// headers: {
							//     "content-type": 'application/json'
							// },
							body: JSON.stringify(this.state.user_data),
						});

						const loginRes = await loginRespnse.json();

						const responseLogin = await JSON.parse(loginRes);
						const { data, response, status } = responseLogin;
						if (status === "SUCCESS") {
							window.open(
								`${REDIRECT_URL}/autologin?continue=${data.product_cms_full_url}&token=${response.refresh_token}`,
								"_blank"
							);
							//                          window.open(`${data.urlEndPoint}`, '_blank');
						}
					} catch (error) {
						console.log(error);
					}
				}
			);
		}
	};

	fetchProductByKey = (key) => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${key}", type: \"Lead\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, country_name, number_of_login, domain_name}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						this.setState({
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
							Loading: 0,
						});
					});
			}
		);
	};

	getMuvisixCustomer = (event, cond = 0) => {
		this.setState({ isMuviOne: false });

		if (cond == 1) {
			var prod_key = event.target;
		} else {
			const { value } = event.target;
			var prod_key = value;
		}

		if (prod_key !== "") {
			if (prod_key == "3D28C83C85544F0D9517DD2E7C7EEDAA") {
				this.setState({ isMuviOne: true });
			}

			this.setState(
				{
					Loading: 1,
					search: "",
				},
				() => {
					this.getCustomersforSearch();

					fetch("https://apigateway.muvi.com/customer-list", {
						method: "POST",
						dataType: "json",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							query: `{getCustomerList( product_key: "${prod_key}", type: \"Lead\", page: 0, size: 20, offset : 0) {page_info{total_count}, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, country_name, number_of_login, domain_name}}}`,
						}),
					})
						.then((Response) => Response.json())
						.then((findresponse) => {
							this.setState({
								customers: findresponse.data.getCustomerList.user_details,
								item_count: findresponse.data.getCustomerList.page_info.total_count,
								Loading: 0,
								activePage: 1,
								setPage: "yes",
							});
						});

					this.setState({
						muvisixproductkey: prod_key,
					});
				}
			);
		} else {
			this.setState(
				{
					activePage: 1,
					customerByproductName: [],
					search: "",
				},
				() => {
					this.getCustomers(1);
				}
			);
		}
	};

	getCustomersforSearch = (page = 1) => {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetLeads/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					muviFiveCount: findresponse.item_count,
				});
			});
	};

	getCustomersMenu(
		studio_id,
		studio_name,
		user_id,
		email,
		encrypted_password,
		name,
		productkey = null,
		apptoken = null,
		leadToDemo = null,
		useruid = null,
		uname = null,
		storeKey,
		free_trial_expiry_date = null,
		company_name = null
	) {
		if (this.state.store_permission == 1) {
			const tattleProductKey = "15814865095e4391ada3222422565574";
			return this.state.showMenu ? (
				<ul class="onclick-menu-content">
					{this.state.muvisixproductkey !== "" ? (
						<li onClick={() => this.userDataEncrypt(productkey, useruid, uname)}>
							<a>Log-In to Account</a>
						</li>
					) : (
						<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
							<a>Log-In to Account</a>
						</li>
					)}
					{this.state.muvisixproductkey == "" ? (
						<li
							onClick={() => this.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#changePassword"
						>
							<a>Change Password</a>
						</li>
					) : (
						""
					)}
					{this.state.muvisixproductkey !== "" && this.state.muvisixproductkey !== tattleProductKey ? (
						<li
							onClick={() =>
								this.leadMovetoDemo(productkey, apptoken, leadToDemo, useruid, uname, name, storeKey)
							}
						>
							<a>Move to Demo</a>
						</li>
					) : this.state.muvisixproductkey == "" ? (
						<li onClick={() => this.movetoDemo(studio_id, studio_name, user_id)}>
							<a>Move to Demo</a>
						</li>
					) : (
						""
					)}
					{this.state.muvisixproductkey == "" ? (
						<li
							onClick={() => this.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#cancelAccount"
						>
							<a>Cancel Account</a>
						</li>
					) : (
						""
					)}
					{this.state.muvisixproductkey == "" ? (
						<li
							onClick={() => this.customer_details(studio_id, studio_name, user_id)}
							data-toggle="modal"
							data-target="#extendfreetrial"
						>
							<a>Extend Free Trial</a>
						</li>
					) : (
						<li
							onClick={() =>
								this.get_customer_details(
									apptoken,
									productkey,
									storeKey,
									useruid,
									free_trial_expiry_date,
									company_name
								)
							}
							data-toggle="modal"
							data-target="#extendfreetrial"
						>
							<a>Extend Free Trial</a>
						</li>
					)}
					{this.state.muvisixproductkey != "" ? (
						<li
							onClick={() => this.setInvoiceDetails(useruid, company_name)}
							data-toggle="modal"
							data-target="#raiseInvoiceModal"
						>
							<a>Raise Custom Invoice</a>
						</li>
					) : (
						""
					)}
				</ul>
			) : (
				""
			);
		} else {
			return (
				<ul class="onclick-menu-content">
					{this.state.is_general_user != 1 ? (
						this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, uname)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)
					) : (
						""
					)}
				</ul>
			);
		}
	}
	handlePageChange(pageNumber = 1) {
		if (this.state.muvisixproductkey != "") {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${
							this.state.muvisixproductkey
						}", type: \"Lead\", page: ${pageNumber - 1}, search: \"${
							this.state.search
						}", size: 20) {page_info{total_count}, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, country_name, number_of_login, domain_name}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
							//                    offset: findresponse.data.getCustomerList.offset,
							loading: 0,
							activePage: pageNumber,
							setPage: "yes",
						});
					});
			}
		} else {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch(
					this.state.apiUrl +
						"/adminRest/GetLeads/page/" +
						pageNumber +
						"/userAuthKey/" +
						this.state.userAuthKey +
						"/userId/" +
						this.state.userId,
					{
						method: "POST",
						dataType: "json",
						body: JSON.stringify(this.state),
					}
				)
					.then((Response) => Response.json())
					.then((findresponse) => {
						findresponse = this.rawjsonparse(findresponse, 1);
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.customers,
							offset: findresponse.offset,
							off_count: findresponse.off_count,
							setPage: "yes",
						});
					});
			}
		}
	}
	getCustomers(page = 1) {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetLeads/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					item_count: findresponse.item_count,
					store_permission: findresponse.store_permission,
					is_general_user: findresponse.is_general_user,
					purchase_url: findresponse.purchase_url,
					muviFiveCount: findresponse.item_count,
					Loading: 0,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
					muvisixproductkey: "",
				});
			});
	}

	getMuviClassicCount(type = "") {
		const customer_type = { type: type };
		fetch("https://cms.muvi.com/intranet/getMuvi5TotalCounts", {
			method: "POST",
			body: JSON.stringify(customer_type),
		})
			.then((Response) => Response.json())
			.then((data) => {
				this.setState({
					muviFiveCount: data.total_count,
				});
			});
	}

	componentDidMount() {
		//        this.getCustomers(1, 1);
		this.getMuviClassicCount(2);
		var muvi_one_prod_key = { target: "3D28C83C85544F0D9517DD2E7C7EEDAA" };
		const muvi_one_product_key = Object.assign({}, muvi_one_prod_key);
		this.getMuvisixCustomer(muvi_one_product_key, 1);

		document.title = "Intranet | Leads";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
		// fetch(this.state.apiUrl +'/adminRest/getAllMuviSixProduct/userAuthKey/' + this.state.userAuthKey,{

		// method: 'GET',

		// }).then( Response => Response.json())
		//     .then( (data) =>{

		//     this.setState({

		//         allmuvisix: data
		//     })
		// })
		if (this.props.muvisixproductkey !== "") {
			const customer_section = { customer_section: 1 };
			fetch(this.state.apiUrl + "/RevenueRest/activeProductStatistics/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
				body: JSON.stringify(customer_section),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.setState({
						allmuvisix: data.data,
					});
				});
		}
	}
	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}

	muviSixpagination = () => {
		if (20 * (this.state.activePage - 1 + 1) > this.state.item_count) {
			return (
				20 * (this.state.activePage - 1) + 1 + " - " + this.state.item_count + " of " + this.state.item_count
			);
		} else {
			return (
				20 * (this.state.activePage - 1) +
				1 +
				" - " +
				20 * (this.state.activePage - 1 + 1) +
				" of " +
				this.state.item_count
			);
		}
	};
	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}
	getLeadList() {
		let hideSearchforMuvisix = "";

		hideSearchforMuvisix = (
			<div class="searchTicket mob_customer">
				<input
					type="text"
					value={this.state.search}
					class="form-control"
					name="customer"
					id="customer"
					placeholder="Search company, name or email"
					onChange={this.keywordChange}
				/>
				<button type="submit">
					<i class="fa fa-search"></i>
				</button>
			</div>
		);

		return (
			<section class="customer">
				<div id="exTab1" class="container">
					<CustomerTabMenu brecum_page="leadlist" />
					<div class="tab-content clearfix">
						<div class="tab-pane active" id="Leads">
							<div class="row">
								<div class="col-md-5">
									<div class="row">
										<div class="col-md-7">
											<select
												className="form-control"
												value={this.muvisixproductkey}
												onChange={this.getMuvisixCustomer}
											>
												{this.state.allmuvisix.map((item, index) => {
													return item.product_key != "49F37046FCD84520895FC18A4F5BFC8B" ? (
														item.product_key == "3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
															<option value={item.product_key} key={index} selected>
																{item.product_name} ({item.leads})
															</option>
														) : (
															<option value={item.product_key} key={index}>
																{item.product_name} ({item.leads})
															</option>
														)
													) : (
														<option value="">
															Muvi One (Classic) ({this.state.muviFiveCount})
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>

								<div class="col-md-1"></div>

								<div class="col-md-6">{hideSearchforMuvisix}</div>
							</div>

							<div class="list_check">
								<div class="tickets hidden-sm">
									<ul class="tickets_head">
										<li
											class={
												this.state.muvisixproductkey !== "" ? "intra_col_10" : "intra_col_10"
											}
										>
											Company
										</li>
										<li
											class={
												this.state.muvisixproductkey !== "" ? "intra_col_12" : "intra_col_12"
											}
										>
											Name
										</li>
										<li
											class={
												this.state.muvisixproductkey !== "" ? "intra_col_10" : "intra_col_10"
											}
										>
											Email
										</li>
										{this.state.muvisixproductkey === "" || this.state.isMuviOne ? (
											<li
												class={
													this.state.muvisixproductkey !== ""
														? "intra_col_10"
														: "intra_col_10"
												}
											>
												Website
											</li>
										) : (
											""
										)}
										<li
											class={this.state.muvisixproductkey != "" ? "intra_col_12" : "intra_col_12"}
										>
											Country
										</li>
										<li
											class={
												this.state.muvisixproductkey === "" ? "intra_col_10" : "intra_col_10"
											}
										>
											Logins
										</li>
										<li
											class={
												this.state.muvisixproductkey === "" ? "intra_col_15" : "intra_col_15"
											}
										>
											Joined On
										</li>
										<li
											class={
												this.state.muvisixproductkey === "" ? "intra_col_15" : "intra_col_15"
											}
										>
											Source
										</li>
										<li class="intra_col_5"></li>
									</ul>
									{this.state.Loading ? (
										<div>
											<div class="loader-new"></div>
										</div>
									) : (
										this.state.customers.map((data, key) => (
											<ul class="tickets_number">
												<li class="intra_col_10 text-inded">
													{this.state.muvisixproductkey == "" ? (
														<Link
															key={key}
															to={`/test/detail/${data.studio_id}`}
															name={"max"}
														>
															{" "}
															{data.company_name
																? data.company_name
																: data.name
																? data.name
																: "NA"}
														</Link>
													) : (
														<Link
															key={key}
															to={`/test/detail/${data.app_token}`}
															name={"max"}
														>
															{" "}
															{data.company_name
																? data.company_name
																: data.name
																? data.name
																: "NA"}
														</Link>
													)}
												</li>
												<li
													class={
														this.state.muvisixproductkey !== ""
															? "intra_col_12 text-inded"
															: "intra_col_12 text-inded"
													}
												>
													{data.first_name ? data.first_name : data.name ? data.name : "NA"}
												</li>
												<li
													class={
														this.state.muvisixproductkey !== ""
															? "intra_col_10"
															: "intra_col_10"
													}
												>
													{data.email ? data.email : "NA"}
												</li>
												{this.state.muvisixproductkey == "" || this.state.isMuviOne ? (
													<li
														class={
															this.state.muvisixproductkey !== ""
																? "intra_col_10 text-inded"
																: "intra_col_10 text-inded"
														}
													>
														<a
															href={`http://${
																data.domain ? data.domain : data.domain_name
															}`}
															target="_blank"
														>
															{data.domain ? data.domain : data.domain_name}
														</a>
													</li>
												) : (
													""
												)}
												<li
													class={
														this.state.muvisixproductkey != ""
															? "intra_col_12 text-inded"
															: "intra_col_12 text-inded"
													}
												>
													{data.country
														? data.country
														: data.country_name
														? data.country_name
														: "NA"}
												</li>
												<li
													class={
														this.state.muvisixproductkey === ""
															? "intra_col_10"
															: "intra_col_10"
													}
												>
													{data.logins
														? data.logins
														: data.number_of_login
														? data.number_of_login
														: "NA"}
												</li>
												<li
													class={
														this.state.muvisixproductkey === ""
															? "intra_col_15"
															: "intra_col_15"
													}
												>
													{data.created_at_change
														? new Date(data.created_at_change).toLocaleDateString("en-US", {
																month: "short",
																day: "numeric",
																year: "numeric",
														  })
														: new Date(data.created_date).toLocaleDateString("en-US", {
																month: "short",
																day: "numeric",
																year: "numeric",
														  })}
												</li>
												<li
													class={
														this.state.muvisixproductkey === ""
															? "intra_col_10"
															: "intra_col_15"
													}
												>
													<div class="text-inded">
														{data.source ? this.getSourceLink(data.source) : "NA"}
														{/*<a href={this.state.purchase_url + 'signup/purchasesubscription.html?studio=' + data.uniqid}>{this.state.purchase_url + 'signup/purchasesubscription.html?studio=' + data.uniqid}</a>*/}
													</div>
												</li>{" "}
												{/* <li class="intra_col_5 customer_details" onClick={ () => this.setState({ menusOpen: !false})}>
                                                        <div tabindex="0" class="onclick-menu c-details pull-right">
                                                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                            { this.state.menusOpen ? this.getCustomersMenu(data.studio_id, data.first_name, data.user_id, 
                                                            data.email, data.encrypted_password, data.name, 
                                                            this.state.muvisixproductkey,data.app_token, true, data.user_uuid, data.username) : ''}
                                                        </div>
                                                    </li>  */}
												<li
													onClick={this.menuHideShow}
													style={{ position: "relative" }}
													className="intra_col_5"
												>
													{this.state.is_general_user != 1 ? (
														<div tabindex="0" class="onclick-menu c-details pull-right">
															<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
															{this.getCustomersMenu(
																data.studio_id,
																data.first_name,
																data.user_id,
																data.email,
																data.encrypted_password,
																data.name,
																this.state.muvisixproductkey,
																data.app_token,
																true,
																data.user_uuid,
																data.username,
																data.store_key,
																data.free_trial_expiry_date,
																data.company_name
															)}
														</div>
													) : (
														<div></div>
													)}
												</li>
											</ul>
										))
									)}
								</div>
							</div>
						</div>
					</div>
					<div class="customer_mob hidden-md">
						{this.state.customers.map((data, key) => (
							<div class="custmer_list_mob">
								<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
									<h4 class="list_title">{data.first_name}</h4>
								</Link>
								<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
									<div class="wrap">{data.domain}</div>
								</Link>
								{this.state.is_general_user != 1 ? (
									<div tabindex="0" class="onclick-menu pull-right">
										<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
										{this.getCustomersMenu(
											data.studio_id,
											data.first_name,
											data.user_id,
											data.email,
											data.encrypted_password,
											data.name,
											data.store_key
										)}
									</div>
								) : (
									<div></div>
								)}
							</div>
						))}
					</div>
					{this.state.Loading ? (
						""
					) : (
						<span>
							{this.state.item_count > 0 ? (
								<div class="pagination-muvi">
									<Pagination
										itemClass={"pages"}
										itemClassFirst={"first_page"}
										itemClassPrev={"prev_page"}
										itemClassNext={"next_page"}
										itemClassLast={"last_page"}
										activePage={this.state.activePage}
										itemsCountPerPage={20}
										totalItemsCount={this.state.item_count}
										pageRangeDisplayed={5}
										onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
									/>
									<div style={{ color: "#333" }}>
										{this.state.muvisixproductkey == ""
											? this.state.offset +
											  1 +
											  " - " +
											  (this.state.offset + this.state.off_count) +
											  " of " +
											  this.state.item_count
											: this.muviSixpagination()}
									</div>
								</div>
							) : (
								<div className="text-center" style={{ color: "#333" }}>
									No Data Found
								</div>
							)}
						</span>
					)}
					{/* {this.loadMorecount()} */}
				</div>
			</section>
		);
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}

		return (
			<div>
				{/* <--Extend Free Trial-!> */}
				<div class="modal fade" id="extendfreetrial" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Extend Free Trial
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={
										this.state.muvisixproductkey == ""
											? this.state.studio_id.name
											: this.state.company_name
									}
									className="form-control"
									readOnly
								/>

								<label>
									<b>Extend Till Date</b>
								</label>

								<DatePicker
									selected={
										this.state.muvisixproductkey == ""
											? this.state.startDate
											: this.state.free_trial_expiry_date
									}
									selectsStart
									startDate={
										this.state.muvisixproductkey == ""
											? this.state.startDate
											: this.state.free_trial_expiry_date
									}
									onChange={
										this.state.muvisixproductkey == ""
											? this.handleChangeStart
											: this.handleChangeStartMuvi6
									}
									minDate={this.state.minDate}
									dateFormat="dd-MM-yyyy"
									peekNextMonth
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
									onKeyDown={(e) => e.preventDefault()}
								/>

								<span style={{ color: "red" }}>{this.state.message1}</span>
								<br />
							</div>
							<div class="modal-footer">
								<button
									type="button"
									class="btn btn-blue"
									data-dismiss="modal"
									id="extend_free_trial_close"
								>
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.state.muvisixproductkey == ""
											? this.ExtendTrialPeriod(this.state.studio_id.id, this.state.user_id.id)
											: this.ExtendTrialPeriodMuvi6(
													this.state.free_trail_apptoken,
													this.state.free_trail_productkey,
													this.state.free_trail_storeKey,
													this.state.free_trail_useruid,
													this.state.new_free_trial_date
											  )
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for FreeTrial-!> */}

				{/* <--modal start for cancelling account-!> */}
				<div class="modal fade" id="cancelAccount" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Cancel Account
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={this.state.studio_id.name}
									className="form-control"
									onChange={this.onChange}
									readOnly
								/>

								<input
									type="hidden"
									value={this.state.studio_id.id}
									name="studio_id"
									onChange={this.onChange}
								/>
								<input
									type="hidden"
									value={this.state.user_id.id}
									name="user_id"
									onChange={this.onChange}
								/>
								<br />
								<label>
									<b>Reason</b>
								</label>
								<textarea
									style={{ resize: "none" }}
									class="form-control"
									name="custom_notes"
									id="custom_notes"
									required
									onChange={this.onChange}
								></textarea>
								<span style={{ color: "red" }}>{this.state.message1}</span>
								<br />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-default"
									onClick={() => this.CancelAccount(this.state.studio_id.id, this.state.user_id.id)}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for cancelling account-!> */}

				{/* <--modal start for change Password-!> */}
				<div class="modal fade" id="changePassword" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Update Password
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>New Password</b>
								</label>
								<input
									type="text"
									name="new_password"
									id="new_password"
									className="form-control"
									onChange={this.onChange}
								/>
								<span style={{ color: "red" }}>{this.state.message}</span>
								<input type="hidden" value={this.state.studio_id.id} name="studio_id" />
								<input type="hidden" value={this.state.user_id.id} name="user_id" />
							</div>

							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-default"
									onClick={() => this.Savepassword(this.state.studio_id.id, this.state.user_id.id)}
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>

				{/* <--raise invoice for muvi 6-!> */}
				<div class="modal fade" id="raiseInvoiceModal" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Raise Invoice
								</h4>
							</div>
							<div class="modal-body">
								<div class="form-group">
									<label class="span2 control-label" for="company" style={{ fontSize: "20px" }}>
										{this.state.customer_name_muvi6}
									</label>
								</div>
								Title
								<input
									type="text"
									class="form-control"
									name="item_name"
									value={this.state.item_name}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_name"]}</span>
								<br></br>
								Description
								<input
									type="text"
									class="form-control"
									name="item_description"
									value={this.state.item_description}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_description"]}</span>
								<br></br>
								Amount($)
								<input
									type="text"
									class="form-control"
									name="invoice_amount"
									value={this.state.invoice_amount}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["invoice_amount"]}</span>
								<br></br>
							</div>
							<span style={{ color: "red" }}>
								{this.props.message && this.flag == 1 ? this.props.message : ""}
							</span>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									name="submit_invoice"
									id="submit_invoice"
									class="btn btn-sky"
									onClick={() => this.submitInvoice()}
								>
									Submit Invoice
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for -!> */}

				{/* <--modal end for change Password-!> */}
				<Header brecum_name="Customer" brecum_page="Leads" />
				<div className="right_col">{this.getLeadList()}</div>
			</div>
		);
	}
}

export default LeadList;



// WEBPACK FOOTER //
// ./src/components/customer/LeadsList.js